export class BeanSlideOperacao{
  constructor(
    public operIdCdOperacao  : string,
    public operNmOperacao	 : string,
    public operDsCentroCusto : string,
    public operDhRegistro	 : string,
    public operDhInativo	 : string,
    public slide	 : boolean,

  ){}
}